export const delivery = 1000105;
export const collection = 1000106;
